import { mainRegion } from "@/components/Header/Info";
import { IRegion } from '@/types/region';

const CURRENT_REGION_NAME = 'region_v1';

export const getLSRegion = ():IRegion  => {
  const regionString = window.localStorage.getItem(CURRENT_REGION_NAME);
  return regionString ? JSON.parse(regionString) : mainRegion;
}

export const setLSRegion = (region: IRegion) => {
  const regionString = JSON.stringify(region);
  window.localStorage.setItem(CURRENT_REGION_NAME, regionString);
}